import DataSourceMapping from "./DataSourceMapping";

export default DataSourceMapping;
